import request from '@/utils/request';


//查询节点列表
export function searchPerformanceList(data) {
  return request({
    url: `/basic-backend/performance/list`,
    method: "post",
    data
  });
}

//查询订单详情
export function getPerformanceOrderList(data) {
  return request({
    url: `/basic-backend/performance/order/list`,
    method: "post",
    data
  });
}

//获取违规类型
export function getEnumOrderBreak() {
  return request({
    url: `/basic-backend/performance/enum/order/break`,
    method: "get",
  });
}

//获取大区列表
export function getGeographyList(params) {
  return request({
    url: `/basic-backend/performance/geography/list`,
    method: "get",
    params
  });
}

//获取大区列表 new 新增 businessRegionId businessRegionName
export function getBusinessRegionList(params) {
  return request({
    url: `/basic-backend/performance/business/region/list`,
    method: "get",
    params
  });
}

//导出节点列表
export function exportPerformanceList(data) {
  return request({
    url: `/basic-backend/performance/export/list`,
    method: "post",
    data
  });
}

export function exportPerformanceOrderList(params) {
  return request({
    url: `/basic-backend/performance/export/order/list`,
    method: "get",
    params
  });
}

export function getDefaultReasonList() {
  return request({
    url: `/basic-backend/performance/defaultReasonList`,
    // method: "post",
  });
}

export function getExemptionReasonList() {
  return request({
    url: `/basic-backend/performance/exemptionReasonList`,
    // method: "post",
  });
}

export function getExemptionAuditList(data) {
  return request({
    url: `/basic-backend/performance/exemption/auditList`,
    method: "post",
    data,
  });
}

export function getExemptionDetailAuditList(params) {
  return request({
    url: `/basic-backend/performance/exemption/detail/auditList`,
    params,
  });
}

export function batchRejectOrPass(data) {
  return request({
    url: `/basic-backend/performance/exemption/batchRejectOrPass`,
    method: "post",
    data,
  });
}

export function editExemption(data) {
  return request({
    url: `/basic-backend/performance/exemption/edit`,
    method: "post",
    data,
  });
}

export function batchSaveExemption(data) {
  return request({
    url: `/basic-backend/performance/exemption/batchSave`,
    method: "post",
    data,
  });
}
